import React, { useState } from 'react';
import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/outline';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = "Name is required";
    if (!formData.email.includes('@') || !formData.email.includes('.')) errs.email = "Please enter a valid email address";
    if (!formData.message.trim()) errs.message = "Message cannot be empty";
    if (formData.message.length > 500) errs.message = "Message cannot exceed 500 characters";
    return errs;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) return setErrors(errs);
    alert("Message Sent Successfully!");
    setFormData({ name: '', email: '', message: '' });
    setErrors({});
  };

  return (
    <div className="bg-gradient-to-b from-orange-50 to-yellow-50 text-gray-800 font-sans min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <section className="max-w-3xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold text-orange-600 mb-8 flex items-center gap-3 animate-slide-in-top">
          <EnvelopeIcon className="w-8 h-8 text-orange-600" />
          Contact Us
        </h1>
        <p className="text-center text-lg sm:text-xl text-gray-600 mb-10 animate-fade-in">
          Reach out to us with any questions or feedback. We're here to assist you!
        </p>
        <div className="bg-white p-6 rounded-xl shadow-lg animate-slide-in">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                className="w-full border border-gray-300 rounded-lg p-3 text-base focus:outline-none focus:ring-2 focus:ring-orange-600 transition duration-300"
                placeholder="Your Name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
              {errors.name && <p className="text-red-500 text-sm mt-1 animate-fade-in">{errors.name}</p>}
            </div>

            <div>
              <input
                className="w-full border border-gray-300 rounded-lg p-3 text-base focus:outline-none focus:ring-2 focus:ring-orange-600 transition duration-300"
                placeholder="Your Email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
              {errors.email && <p className="text-red-500 text-sm mt-1 animate-fade-in">{errors.email}</p>}
            </div>

            <div>
              <textarea
                className="w-full border border-gray-300 rounded-lg p-3 text-base focus:outline-none focus:ring-2 focus:ring-orange-600 transition duration-300"
                placeholder="Your Message (max 500 characters)"
                rows="5"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              />
              {errors.message && <p className="text-red-500 text-sm mt-1 animate-fade-in">{errors.message}</p>}
              <p className="text-sm text-gray-500 mt-1">{formData.message.length}/500 characters</p>
            </div>

            <button
              type="submit"
              className="w-full bg-orange-600 text-white px-6 py-3 rounded-lg hover:bg-orange-700 transition duration-300 text-base font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              Send Message
            </button>
          </form>
        </div>
        <div className="mt-10 text-center animate-fade-in">
          <p className="flex items-center justify-center gap-3 text-lg text-gray-700 mb-4">
            <PhoneIcon className="w-6 h-6 text-orange-600" />
            +91 98765 43210
          </p>
          <p className="flex items-center justify-center gap-3 text-lg text-gray-700 mb-4">
            <EnvelopeIcon className="w-6 h-6 text-orange-600" />
            support@fireworkssafety.com
          </p>
          <p className="text-sm text-gray-500 italic">
            Our team is available Monday to Friday, 9 AM to 5 PM IST. Expect a response within 24-48 hours.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contact;
